import io from "socket.io-client";
import { siteConfig } from '../variables/config';
import { getAnonymousToken, getToken, pathMaker, playSound } from "./useful";
import * as actions from '../stores/actionsList';
import store from '../stores/storeConfig';
import Security from './Security.services'
import { nanoid } from "nanoid";


const requestSecurity = new Security()

class SocketServices {


    socket = null
    userId
    acticeTopics = {}
    openSocket = false
    disconnected = false

    emit = (topic, message, extra, cb) => {

        // console.log("emit")
        // console.log(topic)
        // console.log(message)
        // console.log(this.socket)

        // return
        if (this.socket?.connected) {
            // console.log("TP2")
            // return
            delete message.tempFile

            this.socket.emit(topic, message, (info, err) => {

                // console.log("EMIT CB")
                // console.log(info)
                // console.log(err)

                if (cb) {
                    cb(info, err)
                }
            })
        }
    }


    sendMessage(messenger, message) {

        // console.log('sendMessage')
        // console.log(message)

        if (message) {

            // console.log("tp1")
            let tempId = message?.tempId ?? nanoid()

            // console.log(tempId)

            store.dispatch(actions.addQueueMessage(tempId, message, { messenger, type: 'message' }))

            // console.log("tp2")

            setTimeout(() => {
                this.checkMessageQueque()
            }, 10);
        }

        // this.emit('sendMessage', message, null, () => {

        // })

    }


    checkMessageQueque = () => {


        let messages = [...store.getState().queque?.messages]
        // console.log("checkMessageQueque", messages)
        // console.log(messages)
        if (Array.isArray(messages) && messages.length > 0) {

            if (this.currentMessageIndex == null) {

                this.currentMessageIndex = true
                let current = messages[0]
                // console.log(current)
                // console.log("checkMessageQueque")

                if (current.source?.type == 'message') {

                    // console.log("HERE!!")
                    // console.log("HERE!!")
                    this.emit('sendMessage', current.message, null, (info, err) => {


                        // console.log(info)
                        // console.log(err)


                        store.dispatch(actions.updateQueueMessage(current.tempId, 'done', 'uploads'))
                        store.dispatch(actions.changeTempMessage(current.source.messenger, current.tempId, info))


                        setTimeout(() => {
                            this.currentMessageIndex = null

                            // console.log("FINISHED")
                            this.checkMessageQueque()

                        }, 50);

                    })

                }


            }
        }

    }



    sendTheTempMessage(tempId, source) {

        let messages = store.getState().messengers?.messages
        let message

        if (messages && source.messenger) {
            messages[source.messenger].forEach(element => {
                if (element.tempId == tempId) {
                    message = element
                }
            })

            if (message) {
                this.sendMessage(message.messenger, message)
            }

        }
    }




    addTopic(moduleId, id, type, settings, updateFunction) {

        let topic = type
        if (id) {
            topic = type + '-' + id
        }

        if (!this.acticeTopics[topic]) {
            this.acticeTopics[topic] = { id, type }
            this.subscribeTopic({ id, type, settings })

            if (!this.acticeTopics[topic].modules) {
                this.acticeTopics[topic].modules = {}
            }
        }

        this.acticeTopics[topic].modules[moduleId] = { id: moduleId, settings, updateFunction }

    }


    removeTopic(moduleId, id, type, settings) {

        let topic = type
        if (id) {
            topic = type + '-' + id
        }

        if (this.acticeTopics[topic] && this.acticeTopics[topic].modules) {

            delete this.acticeTopics[topic].modules[moduleId]

            if (Object.keys(this.acticeTopics[topic].modules).length == 0) {
                delete this.acticeTopics[topic]
                this.unsubscribeTopic({ id, type, settings })
            }
        }

        // console.log(this.acticeTopics)
    }


    subscribeTopic(topic) {

        if (this.socket) {
            this.socket.emit('subscribeTopic', topic, () => {
            })
        }
    }


    unsubscribeTopic(topic) {
        if (this.socket) {
            this.socket.emit('unsubscribeTopic', topic, () => {
                // console.log("FEEDBACK")
            })
        }
    }


    initTopic() {
        // console.log("initTopic")
        Object.values(this.acticeTopics).forEach(acticeTopic => {
            this.subscribeTopic(acticeTopic)
        });
    }



    closeSocket() {
        if (this.socket) {
            // console.log("CLOSE SOCKET")
            this.socket.disconnect()
            this.socket.close()
            this.socket = null
        }
    }
    handleRoomInvitation = (request) => {
        if (!Array.isArray(request)) {
            request = [request]
        }
        store.dispatch(actions.appendRoomInvite(request))
        // console.log('invited')
    }
    handleAcceptCall = (request) => {
        console.log('appendCall132', request)
        let req = [{ roomId: request.room, type: 'outgoing' }]
        // console.log('req is', req)
        if (request.status) {
            if (!Array.isArray(request)) {
                request = [request]
            }
            store.dispatch(actions.appendCall(request))
            store.dispatch(actions.removeOutgoingCall(req))
            // console.log('accepted')
        }
        else {
            if (!Array.isArray(request)) {
                request = [request]
            }
            store.dispatch(actions.removeRoomInvite(request))
            store.dispatch(actions.removeOutgoingCall(req))

        }
    }

    handleTaskRequest = (config) => {
        if (config.task) {
            let task = config.task
            // console.log('task', task);
            if (!Array.isArray(task)) {
                task = [config.task]
            }
            store.dispatch(actions.appendInbox(task, 'tasks'))
        }
        else {
            if (!Array.isArray(config)) {
                config = [config]
            }
            store.dispatch(actions.appendReservation(config))
        }
    }



    sendNotif = (data) => {

        // console.log('sendNotif10', data)

        let notif = data.notif
        let inbox = data.inbox

        if (!Array.isArray(notif)) {
            notif = [notif]
        }
        if (notif[0].action == 'update') {

            store.dispatch(actions.updateInbox(notif))

        } else {
            console.log("sendNotif", data)
            store.dispatch(actions.addNotif({ type: 'notif', applet: notif[0].applet, appletHub: notif[0].appletHub, frame: notif[0].frame, title: notif[0].title, description: notif[0].description, notif: notif[0] }))
            store.dispatch(actions.updateInbox(inbox))

            this.sendToSubscribedTopics('inboxUpdate', inbox, 'newInbox')
            this.sendToSubscribedTopics('notifUpdate', notif, 'new')

            playSound('chatMessage')

        }
    }

    updateNotif = (data) => {


        let notif = data.notif
        let inbox = data.inbox


        if (inbox) {
            // console.log("inbox",inbox)
            store.dispatch(actions.updateInbox(inbox))
            this.sendToSubscribedTopics('inboxUpdate', inbox, 'updateInbox')
        }

        if (notif) {
            this.sendToSubscribedTopics('notifUpdate', notif, 'update')
        }


    }


    sendToSubscribedTopics = (topic, data, type) => {

        if (this.acticeTopics[topic] && this.acticeTopics[topic].modules) {
            Object.values(this.acticeTopics[topic].modules).forEach(module => {
                module.updateFunction(data, type)
            });
        }

    }

    sendMessageNotif = (info) => {

        let windows = store.getState()?.user?.windows
        let messenger = info.messenger
        let windowIsActive = false


        if (windows && typeof windows == 'object') {
            Object.entries(windows)?.map(([key, value]) => {

                // TO DO: This logic should be improved
                if (Array.isArray(value.data?.path) && (value.data?.path[value.data?.path.length - 1] == messenger?._id)) {
                    windowIsActive = true
                }

            })
        }


        if (!windowIsActive) {
            let messengersHub = store.getState()?.inbox?.messengersHub

            let applet
            let appletHub
            let frame
            let title = "{{lang}}New message"
            let name = ''
            let image


            if (messenger?.type == 'group' || messenger?.type == 'support') {
                image = messenger?.image
                name = messenger?.name
            } else {
                messenger.users.forEach(element => {
                    if (element?.hub?._id != messengersHub) {
                        image = element.hub?.image
                        name = element.hub?.fullname
                    }
                })
            }

            for (let i = 0; i < info.messenger.interactiveUsers.length; i++) {
                const user = info.messenger.interactiveUsers[i];
                if (user.hub == messengersHub) {
                    frame = user.frame
                    applet = user.frame?.applet
                    appletHub = user.refHub?.fullname
                }
            }


            store.dispatch(actions.addNotif({ type: 'message', name, image, applet: applet, appletHub: appletHub, frame: frame, title: title, message: info.message, messenger: info.messenger, messengersHub }))
            playSound('chatMessage')

        }

    }


    inboxUpdated = (config) => {
        // console.log('inbox is ', config)
        if (!Array.isArray(config)) {
            config = [config]
        }
        store.dispatch(actions.updateInbox(config))
    }
    handleNewTask = (config) => {
        console.log('task', config)
        if (!Array.isArray(config)) {
            config = [config]
        }
        store.dispatch(actions.appendTask(config))
    }
    taskUpdated = (config) => {
        // console.log('task', config)
        // console.log('updated task')
        if (!Array.isArray(config)) {
            config = [config]
        }
        store.dispatch(actions.updateTask(config))
    }
    messengerUpdated = (config) => {
        if (!Array.isArray(config)) {
            config = [config]
        }
        store.dispatch(actions.updateMessengers(config))
    }
    handleNotif = (info) => {
        // console.log(info)
        store.dispatch(actions.updateActions(info))
        this.sendToSubscribedTopics('inboxUpdate', info, 'updateActions')
    }

    msgSeen = (info) => {

        // console.log("msgSeen", info)
        this.sendToSubscribedTopics('inboxUpdate', info, 'messageSeen')
        let userId = store.getState()?.user?.info?._id


        store.dispatch(actions.messageSeen(info?.messenger, info?.message, info.by, userId))


        if (info.by == store.getState()?.inbox?.messengersHub) {

            store.dispatch(actions.messageSeenInbox(info))
        }

    }


    sendInfoToTopics=(message)=>{
            
        if (this.acticeTopics[message.type + '-' + message.id] && this.acticeTopics[message.type + '-' + message.id].modules) {
            // console.log('w',this.acticeTopics[message.type + '-' + message.id].updateFunction);
            Object.values(this.acticeTopics[message.type + '-' + message.id].modules).forEach(module => {

                module.updateFunction(message.data)

            });
        }
    }

    async initSocket() {
        // console.log("INITSOCKET")

        // store.dispatch(store.dispatch)
        // console.log(store.dispatch())
        // console.log(store.getState())

        this.closeSocket()

        // if (!openSocket) {
        this.openSocket = true
        let type
        let token = await getToken()
        if (!token) {
            token = await getAnonymousToken()
            type = 'bot'
        }
        const opts = {
            'path': '/users',
            'reconnection': true,
            'reconnectionDelay': 3000,
            'reconnectionDelayMax': 5000,
            'reconnectionAttempts': 5,
            // 'pingTimeout': 5000,
            // 'pingInterval': 8000,
            // secure: true, reconnection: true, rejectUnauthorized: false,
            // transport : ['websocket'] ,
            // transports: ['websocket', 'polling', 'flashsocket'],
            // transports: ['websocket'], upgrade: false,
            extraHeaders: {
                'authorization': 'bearer ' + token,
                'type': type,
            },
        }

        this.socket = io(siteConfig.socketDomain, opts);

        this.socket.on("connect", () => {
            // console.log(this.socket.id);
            // console.log('socket connected', token)
            // console.log('this.socket', this.socket)
            store.dispatch(actions.changeSetting('socketStatus', true))
            this.initTopic()
            this.sendInfoToTopics({type:'socket',id:'connected'})
        });

        this.socket.on("message", (message, cb) => {
            console.log(message);
            if (cb) {
                cb('OK!!!')
            }
        });

        this.socket.on("disconnect", () => {
            console.log("DISCONNECT Socket"); // undefined
            store.dispatch(actions.changeSetting('socketStatus', false))
            this.disconnected = true

        })

        this.socket.on('reconnect', () => {

            console.log("SOCKET connected")

            setTimeout(() => {
                if (!this.socket.connected) {
                    store.dispatch(actions.changeSetting('socketStatus', 'connecting'))
                }
            }, 5000)




            // console.log("reconnect"); // undefined
        })


        this.socket.on('reconnect_attempt', () => {

            console.log("SOCKET reconnect_attempt")

           
        })

        this.socket.on('connecting', function () {
            console.log("SOCKET connecting")
            setTimeout(() => {
                if (!this.socket.connected) {
                    store.dispatch(actions.changeSetting('socketStatus', 'connecting'))
                }
            }, 5000)

        });




        this.socket.on("connect_error", (err) => {
            console.log(`connect_error due to ${err.message}`);
        })

        this.socket.on("logout", (cb) => {
            console.log("FORCE LOG OUT")
            // store.dispatch(actions.logoutUser())
            // store.dispatch(actions.addNotif({ type: 'error', title: '{{lang}}errors.forceLogout', description: '{{lang}}errors.forceLogoutDesc' }))
            // setTimeout(() => {
            //     window.location = pathMaker('/login')
            // }, 500);
            cb("OK")
        })



        this.socket.on("changeBalance", (message) => {
            // console.log("changeBalance")
            store.dispatch(actions.changeBalance(message))

        })

        this.socket.on("changebalance", (message) => {
            // console.log("changeBalance")
            store.dispatch(actions.changeBalance(message))

        })







        this.socket.on("updateTopic", (message) => {

            this.sendInfoToTopics()
           

        })



        






        this.socket.on("newMessenger", (info) => {

            console.log("newMessenger!", info)
            let myId = store.getState()?.user?.info?._id

            store.dispatch(actions.addMessengers([info.messenger], null, myId))


        })


        this.socket.on("newMsg", (info) => {


            console.log("newMsg", info)
            let message = info?.message
            // console.log('New Message info is', info)
            let userId = store.getState()?.user?.info?._id
            // let myId
            // info.messenger.interactiveUsers.forEach(element => {
            //     if (userId == element.hub) {
            //         myId = element.hub
            //     }
            // })

            if (info.messenger) {

                // console.log("newMsg TP1", info.message?.type)
                // console.log('here', info)

                // let name = info.messenger?.name
                // if (!name) {
                //     info.messenger.interactiveUsers.forEach(element => {
                //         if (element.hub._id != userId && Array.isArray(element.refs)) {
                //             name = element.refs[0]?.hub.fullname
                //         }

                //     })
                // }

                // info.messenger["**name"] = name
                let messenger = info.messenger
                if (!Array.isArray(messenger)) {
                    messenger = [messenger]
                }
                if (info.message?.type != 'action') {

                    // store.dispatch(actions.addMessengers(messenger))

                } else {

                    if (info.message.action.for == 'message') {

                        let message = info.message
                        if (!Array.isArray(message)) {
                            message = [message]
                        }
                        // console.log('new messenger', info.messenger)
                        // console.log('new message', message)
                        store.dispatch(actions.updateMessages(info.messenger._id, message))
                    }
                    else {
                        store.dispatch(actions.updateMessengers(info.messenger._id, message))
                    }
                }
            }

            // console.log("newMsg TP2", info?.socket, this.socket.id)


            if (info?.socket != this.socket.id) {

                if (info.message?.type != 'action') {
                    // console.log('heterererTP2')
                    let messengerId = message.messenger?._id ?? message.messenger
                    store.dispatch(actions.appendOneMessage(messengerId, [message]))

                    // if (userId != message?.sender) {
                    //     if (!info.hub) {
                    //         info.hub = userId
                    //     }
                    //     store.dispatch(actions.messageNewInbox(info))
                    // }
                    // else {

                    //     store.dispatch(actions.messageNewInbox(messengerId,message.sequence,message.sequence))


                    // }

                    this.sendMessageNotif(info)
                }
            }

            // if (!info.hub) {
            info.hub = userId
            // }
            store.dispatch(actions.messageNewInbox(info, (userId == message?.sender)))

            this.sendToSubscribedTopics('inboxUpdate', info, 'newMessage')

        });







        this.socket.on('sendNotif', this.sendNotif)
        this.socket.on('updateNotif', this.updateNotif)
        this.socket.on('newInbox', this.handleTaskRequest)
        this.socket.on('inboxUpdated', this.inboxUpdated)
        this.socket.on("newTask", this.handleNewTask)
        this.socket.on('approvedTaskFeedback', this.taskUpdated)
        this.socket.on('messengerUpdated', this.messengerUpdated)
        this.socket.on('useNotif', this.handleNotif)
        this.socket.on("msgSeen", this.msgSeen);
        this.socket.on('roomInvitation', this.handleRoomInvitation)
        this.socket.on('acceptCall', this.handleAcceptCall)


        // socket.emit('heartbeat', 'alive', () => {
        //     console.log("FEEDBACK")
        // })
        // socket.emit('heartbeat', { name: 'alive' })


        // }

    }


}



// function sendHeartBeat() {

//     setTimeout(() => {
//         // console.log("EMIT")
//         socket.emit('heartbeat', 'alive', () => {
//             console.log("FEEDBACK")
//         })
//         sendHeartBeat()
//     }, 1000);
// }


// function getMessengers(isUpdating, cb) {
//     store.dispatch(actions.changeSetting('socketStatus', "updading"))
//         // this.setState({ isLoading: true })
//     console.log("ISUPDATING")
//     HttpService.request('getMessengers', { isUpdating }, (fetchResult, fetchError) => {
//         // console.warn(fetchError)
//         store.dispatch(actions.changeSetting('socketStatus', false))

//         // console.warn(fetchResult)

//         // this.setState({ isLoading: false })

//         if (fetchError) { this.setState({ error: fetchError.message }); return }

//         store.dispatch(actions.addMessengers(fetchResult.info, true)) //.then(()=>{

//         if (fetchResult.messages) {
//             for (const [key, value] of Object.entries(fetchResult.messages)) {
//                 store.dispatch(actions.addMessages(key, value))
//             }
//         }

//         setTimeout(() => {
//             fetchResult.info.forEach(messenger => {
//                 // console.log("TRY")
//                 messenger.participants.forEach(participant => {
//                     if (participant === userId) {
//                         // console.warn("CHANGE")
//                         store.dispatch(actions.changeLastSeen(messenger._id, (messenger.lastSeen ? messenger.lastSeen[participant] : null)))
//                     }
//                 });
//             })
//         }, 500);



//     });

//     // })



//     // this.setState({ data: fetchResult.info })
//     // })
// }



// })


// const mapStateToProps = state => ({ settings: state.settings, user: state.user, resource: state.resource });
// const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) });

// export const mysocket = connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(socket);

// export const myinitSocket = connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(initSocket);



// export { socket, initSocket, closeSocket, addTopic, removeTopic }
export default new SocketServices();